import { useEffect } from 'react'
import DeviceId from 'utils/detectDevice'
import { domainName } from 'utils/parseDomain'
import { getCookie, createCookie } from 'utils/cookie'
import {
  trackOnPageLoad,
  trackRegInfoOnPageLoad,
  // trackBannerViewOnPageLoad,
} from 'tracking/homepage'

const checkExperiment = () => {
  const revampView = getCookie('revampView')
  const isDomainShaadi = ['shaadi.com'].includes(domainName)
  const arrShaadiBuckets = ['B']
  const arrNonShaadiBuckets = ['I']
  if (
    DeviceId.isDesktop() &&
    (typeof revampView === `undefined` ||
      (isDomainShaadi && revampView !== 'A') ||
      (!isDomainShaadi && revampView !== 'D'))
  ) {
    const bucketVal = isDomainShaadi ? 'A' : 'D'
    createCookie('revampView', bucketVal, 0)
  } else {
    if (
      DeviceId.isMobile() &&
      (typeof revampView === `undefined` ||
        ((isDomainShaadi && !arrShaadiBuckets.includes(revampView)) ||
          (!isDomainShaadi && !arrNonShaadiBuckets.includes(revampView))))
    ) {
      const bucketVal = isDomainShaadi
        ? arrShaadiBuckets[Math.floor(Math.random() * arrShaadiBuckets.length)]
        : arrNonShaadiBuckets[
            Math.floor(Math.random() * arrNonShaadiBuckets.length)
          ]
      createCookie('revampView', bucketVal, 0)
    }
  }

  // GSU AB buckets
  const arrGsuBuckets = ['A', 'B']

  const GsuExp = getCookie('GsuExp')

  if (!GsuExp) {
    const GsuBucket = DeviceId.isMobile()
      ? 'B'
      : arrGsuBuckets[Math.floor(Math.random() * arrGsuBuckets.length)]
    createCookie('GsuExp', GsuBucket, 60 * 60 * 24 * 365)
  }

  // const tvcView = getCookie('tvcView')
  // const arrTvcView = ['default', 'tvcLib']
  // if (
  //   typeof tvcView === `undefined` ||
  //   (isDomainShaadi && !arrTvcView.includes(tvcView)) ||
  //   (!isDomainShaadi && tvcView !== 'default')
  // ) {
  //   const viewVal = isDomainShaadi
  //     ? arrTvcView[Math.floor(Math.random() * arrTvcView.length)]
  //     : 'default'
  //   createCookie('tvcView', viewVal, 0)
  // }
}

export const validateSession = () => {
  if (!getCookie('reg_ust')) {
    const uniqueHash = `${Math.random().toString(16)}000000000`.substr(2, 10)
    const newUst = 'client_' + Date.now() + '_' + uniqueHash
    createCookie('reg_ust', newUst, 0)
  }
}

function SetExperiment(props) {
  useEffect(() => {
    checkExperiment()
    validateSession()
    trackOnPageLoad()
    trackRegInfoOnPageLoad(props.domainCountry)
    // trackBannerViewOnPageLoad()
  }, [])

  return null
}

export default SetExperiment
